import { actions } from "./Actions";

const initialState = {
  categories: {},
  selectedCategoryId: 1,
};

export function products(state = initialState, action) {
  switch (action.type) {
    case actions.RECEIVE_CATEGORIES: {
      return {
        ...state,
        categories: action.categories.filter(category => category.items && category.items.length > 0),
      };
    }
    case actions.SET_SELECTED_CATEGORY_ID: {
      return {
        ...state,
        selectedCategoryId: action.categoryId,
      };
    }
    default:
      return state;
  }
}

export default products
